import React from 'react'
import { useFormContext, useFieldArray } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import FormSubheader from '../create-profile-form/form-subheader'
import TextField from '@material-ui/core/TextField'
import { get } from 'lodash'
import { Testimony } from 'components/coaches-profile/profile-stepper.styles'
import Button from '@material-ui/core/Button'
import TonalButton from 'components/empty-page-state/tonal-button'
import AddIcon from 'components/material-symbol/icons/Add'
import { IconTrashcan } from 'components/atoms/icons'
import {
  getFieldProps,
  requiredLabel,
  useCreateProfileFieldStyles,
} from '../create-profile-form/field-styles'

const MAX_TESTIMONIALS_COUNT = 5
const testimonialsMsg = `Add up to ${MAX_TESTIMONIALS_COUNT} testimonials.`

export const Testimonials = ({
  hideSubheader = false,
  filledDeleteButton = false,
}) => {
  const fieldClasses = useCreateProfileFieldStyles()
  const fieldProps = getFieldProps(fieldClasses)
  const { control, errors, register } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    name: 'testimonialsJsonData',
    control,
  })

  return (
    <Box className={fieldClasses.fieldSection}>
      {!hideSubheader ? (
        <FormSubheader title="Testimonials" description={testimonialsMsg} />
      ) : null}
      <Box className={fieldClasses.fieldStack}>
        {fields.map((item, index) => {
          return (
            <Testimony key={item.id}>
              <Box
                className={fieldClasses.fieldStack}
                style={{ flex: '1 1 auto', marginRight: 16 }}
              >
                <TextField
                  {...fieldProps}
                  multiline
                  minRows={3}
                  name={`testimonialsJsonData[${index}].testimonial`}
                  defaultValue={item.testimonial}
                  label={requiredLabel('Testimonial')}
                  type="text"
                  inputRef={register()}
                  error={
                    !!get(errors, [
                      'testimonialsJsonData',
                      index,
                      'testimonial',
                    ])
                  }
                  helperText={get(errors, [
                    'testimonialsJsonData',
                    index,
                    'testimonial',
                    'message',
                  ])}
                />
                <TextField
                  {...fieldProps}
                  name={`testimonialsJsonData[${index}].author`}
                  defaultValue={item.author}
                  label={requiredLabel('Attestant')}
                  type="text"
                  inputRef={register()}
                  error={
                    !!get(errors, ['testimonialsJsonData', index, 'author'])
                  }
                  helperText={get(errors, [
                    'testimonialsJsonData',
                    index,
                    'author',
                    'message',
                  ])}
                />
                <input
                  type="hidden"
                  ref={register()}
                  name={`testimonialsJsonData[${index}].rank`}
                  value={index + 1}
                />
              </Box>
              <Button
                className={
                  filledDeleteButton
                    ? fieldClasses.repeaterDeleteButtonFilled
                    : fieldClasses.repeaterDeleteButton
                }
                variant={filledDeleteButton ? 'contained' : 'outlined'}
                disableElevation={filledDeleteButton}
                size="large"
                type="button"
                startIcon={<IconTrashcan />}
                onClick={() => remove(index)}
              >
                Delete
              </Button>
            </Testimony>
          )
        })}
        <Box>
          <TonalButton
            type="button"
            startIcon={<AddIcon fontSize="small" />}
            onClick={() => {
              append({ testimonial: '', author: '' })
            }}
            disabled={fields.length >= MAX_TESTIMONIALS_COUNT}
          >
            Add Testimonial
          </TonalButton>
        </Box>
      </Box>
    </Box>
  )
}

export default Testimonials
